import Button from '@mui/material/Button';
import React from 'react';
import PropTypes from 'prop-types';

export const HeaderMenuMain = ({ entries }) => {
  return entries?.map(({ id, linkText, linkTitle, url, onClick }) => (
    <Button

      key={id}
      href={url}
      onClick={onClick}
      title={linkTitle}
      sx={{ my: 2, display: 'block', color: 'primary.contrastText' }}>
      {linkText}
    </Button>
  ));
};

HeaderMenuMain.propTypes = {
  entries: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      linkText: PropTypes.string.isRequired,
      linkTitle: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired
    })
  )
};

export default HeaderMenuMain;
